'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// currently hardcoded to accept and display a single image.
var EnterpriseImgDnD = function (_Component) {
  (0, _inherits3.default)(EnterpriseImgDnD, _Component);

  function EnterpriseImgDnD(props) {
    (0, _classCallCheck3.default)(this, EnterpriseImgDnD);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EnterpriseImgDnD.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseImgDnD)).call(this, props));

    var acceptedFiles = void 0;
    if (props.initialImg) {
      acceptedFiles = [{ preview: props.initialImg }];
    } else {
      acceptedFiles = null;
    }

    _this.state = {
      dragActive: false,
      acceptedFiles: acceptedFiles,
      rejectedFiles: null
    };

    _this.onOpenClick = _this.onOpenClick.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.hasAcceptedFiles = _this.hasAcceptedFiles.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EnterpriseImgDnD, [{
    key: 'hasAcceptedFiles',
    value: function hasAcceptedFiles() {
      var exp1 = Array.isArray(this.state.acceptedFiles);
      var exp2 = exp1 && this.state.acceptedFiles.length > 0;
      return exp1 && exp2;
    }
  }, {
    key: 'onOpenClick',
    value: function onOpenClick() {
      this.dropzone.open();
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(e) {
      if (this.state.dragActive) {
        return;
      }

      this.setState((0, _extends3.default)({}, this.state, {
        dragActive: true
      }));
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave() {
      this.setState((0, _extends3.default)({}, this.state, {
        dragActive: false
      }));
    }
  }, {
    key: 'onDrop',
    value: function onDrop(acceptedFiles, rejectedFiles) {
      this.setState((0, _extends3.default)({}, this.state, {
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles,
        dragActive: false
      }));

      if (this.props.onDrop) {
        this.props.onDrop.call(null, acceptedFiles, rejectedFiles);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showButton = _props.showButton,
          className = _props.className,
          style = _props.style,
          onDrop = _props.onDrop,
          onDragEnter = _props.onDragEnter,
          onDragLeave = _props.onDragLeave,
          initialImg = _props.initialImg,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['showButton', 'className', 'style', 'onDrop', 'onDragEnter', 'onDragLeave', 'initialImg']);


      var rootStyle = {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column'
      };

      return _react2.default.createElement(
        'div',
        { className: className, style: (0, _extends3.default)({}, style, rootStyle) },
        _react2.default.createElement(
          _reactDropzone2.default,
          (0, _extends3.default)({}, restProps, {
            accept: 'image/*',
            className: _styles2.default.drop,
            ref: function ref(node) {
              _this2.dropzone = node;
            },
            multiple: false,
            onDrop: this.onDrop,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave
          }),
          !this.hasAcceptedFiles() && _react2.default.createElement(
            'div',
            {
              className: _styles2.default.spacer
            },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(_styles2.default.messages, (0, _defineProperty3.default)({}, _styles2.default.messagesActive, this.state.dragActive))
              },
              _react2.default.createElement(
                'div',
                { key: 1 },
                'Drag & drop files here'
              ),
              _react2.default.createElement(
                'div',
                { className: _styles2.default.secondary, key: 2 },
                'or you can select them manually'
              )
            )
          ),
          this.state.acceptedFiles && this.state.acceptedFiles.map(function (file) {
            return _react2.default.createElement('img', { className: _styles2.default.contained, key: 0, src: file.preview });
          })
        ),
        showButton && _react2.default.createElement(
          'div',
          { className: _styles2.default.button, onClick: this.onOpenClick },
          'Select files'
        )
      );
    }
  }]);
  return EnterpriseImgDnD;
}(_react.Component);

exports.default = EnterpriseImgDnD;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseImgDnd/EnterpriseImgDnd.jsx
// module id = 1597
// module chunks = 0